module.exports = __webpack_public_path__ + "static/img/aggressive.46b1a5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-culture/aggressive.png
// module id = yjQq
// module chunks = 1